import { type ConfluenceCreateDatabaseCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';
import { logError } from '@databases/logs';

import { getConfluenceService } from '@canvas/atlassian-service/confluence';

import { DatabaseStreamState } from '../database-stream-state';
import { sendDatabaseAIFCExperienceTrackingToParent } from '../metrics/rovo-bridge-database-metrics';

const streamState = DatabaseStreamState.getInstance();

declare global {
  interface Window {
    isPreview?: boolean;
  }
}

export const createDatabase = async (
  params: ConfluenceCreateDatabaseCommandProperties,
  contentId: string
) => {
  try {
    if (params.isStreamComplete && !(globalThis as any).isPreview) {
      try {
        await getConfluenceService().updateContentTitle(contentId, params.data.title);
      } catch (possibleError) {
        const error =
          possibleError instanceof Error
            ? possibleError
            : new Error(String(possibleError));
        logError('Error updating native database title', error);
        throw error;
      } finally {
        await streamState.completeStreaming();
        streamState.scheduleActionedEvaluation(contentId, 'create');
        sendDatabaseAIFCExperienceTrackingToParent({
          status: 'success',
          experienceName: 'aiMateAifcAllDataHandled',
          contentId,
        });
      }
      return;
    }

    if (!streamState.isStreamingActive) {
      sendDatabaseAIFCExperienceTrackingToParent({
        status: 'success',
        experienceName: 'aiMateAifcInitialDataReceived',
        contentId,
      });
      streamState.startStreaming(contentId, params.groupId, {
        shouldClearContent: true,
      });
    }

    streamState.processChunk(params.data.document);
  } catch (possibleError) {
    const error =
      possibleError instanceof Error ? possibleError : new Error(String(possibleError));
    sendDatabaseAIFCExperienceTrackingToParent({
      status: 'fail',
      error,
      experienceName: 'aiMateAifcAllDataHandled',
      contentId,
    });
    throw error;
  }
};
